<template>
  <div class="w-full">
    <vs-popup
      :active.sync="localActive"
      :class="['modal-disparo-massa', abaAtiva === 1 && etapa !== 'progresso' ? 'modal-historico-largo' : '']"
      :title="tituloModal"
      button-close-hidden
    >
      <div id="disparo-massa-container" class="vs-con-loading__container w-full p-4" @click.stop>
        
        <!-- Custom Close Button -->
        <div class="custom-modal-close" @click="closeModal">
          <vs-icon icon="close" size="20px"></vs-icon>
        </div>

        <!-- Input invisível para interceptar o autofocus do Vuesax popup e evitar que caia no ElSelect -->
        <input style="position: absolute; opacity: 0; width: 0; height: 0; border: none; padding: 0; margin: 0; pointer-events: none;" autofocus />

        <!-- ESTADO DE PROGRESSO -->
        <div v-if="etapa === 'progresso'" class="py-4">
          <!-- Header do progresso -->
          <div class="text-center mb-6">
            <vs-icon 
              v-if="progress.status === 'completed' && progress.failed > 0 && progress.sent === 0" 
              icon="cancel" 
              size="48px" 
              color="#ea5455"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon 
              v-else-if="progress.status === 'completed' && progress.failed > 0 && progress.sent > 0" 
              icon="warning" 
              size="48px" 
              color="#ff9f43"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon 
              v-else-if="progress.status === 'completed'" 
              icon="check_circle" 
              size="48px" 
              color="#28c76f"
              class="animate-bounce-in"
            ></vs-icon>
            <vs-icon 
              v-else-if="progress.status === 'error'" 
              icon="error" 
              size="48px" 
              color="#ea5455"
            ></vs-icon>
            <div v-else class="spinner-pulse"></div>
            
            <h4 class="mt-3" :style="{ color: corStatus }">
              <template v-if="progress.status === 'completed'">
                <span v-if="progress.failed > 0 && progress.sent === 0">Envio finalizado com erro!</span>
                <span v-else-if="progress.failed > 0 && progress.sent > 0">Envio finalizado com falhas parciais!</span>
                <span v-else>Processamento finalizado com sucesso!</span>
              </template>
              <template v-else>
                {{ progress.message }}
              </template>
            </h4>
          </div>

          <!-- Barra de Progresso -->
          <div class="progress-container mb-6">
            <div class="progress-info">
              <span class="text-sm font-semibold">Progresso do Envio</span>
              <span class="text-sm font-bold" :style="{ color: corStatus }">{{ progress.percent }}%</span>
            </div>
            <div class="progress-bar-bg">
              <div 
                class="progress-bar-fill" 
                :style="{ width: progress.percent + '%', backgroundColor: corStatus }"
              ></div>
            </div>
          </div>

          <!-- Contadores -->
          <div class="counters-grid">
            <div class="counter-card">
              <vs-icon icon="list_alt" size="24px" color="#00bba2"></vs-icon>
              <span class="counter-value">{{ progress.total }}</span>
              <span class="counter-label">Total</span>
            </div>
            <div class="counter-card counter-success">
              <vs-icon icon="check_circle" size="24px" color="#28c76f"></vs-icon>
              <span class="counter-value text-success">{{ progress.sent }}</span>
              <span class="counter-label">Enviados</span>
            </div>
            <div class="counter-card counter-danger">
              <vs-icon icon="cancel" size="24px" color="#ea5455"></vs-icon>
              <span class="counter-value text-danger">{{ progress.failed }}</span>
              <span class="counter-label">Falhas</span>
            </div>
          </div>

          <!-- Botão Final & Cancelar -->
          <div class="text-center mt-8">
            <template v-if="progress.status === 'completed' || progress.status === 'error' || progress.status === 'cancelled' || progress.status === 'interrupted'">
              <vs-button
                :color="progress.status === 'completed' ? (progress.failed > 0 ? (progress.sent === 0 ? 'danger' : 'warning') : 'success') : (progress.status === 'cancelled' ? 'warning' : 'danger')"
                size="large"
                icon="done_all"
                @click="fecharComSucesso"
              >
                <template v-if="progress.status === 'completed'">
                  <span v-if="progress.failed > 0 && progress.sent === 0">Fechar (Falha Geral)</span>
                  <span v-else-if="progress.failed > 0 && progress.sent > 0">Concluído com Alerta</span>
                  <span v-else>Concluído! Fechar</span>
                </template>
                <template v-else-if="progress.status === 'cancelled'">
                  Cancelado ({{ progress.sent }} Enviados) — Fechar
                </template>
                <template v-else-if="progress.status === 'interrupted'">
                  Interrompido — Fechar
                </template>
                <template v-else>
                  Fechar
                </template>
              </vs-button>
            </template>
            <div v-else class="flex justify-center items-center" style="gap: 12px;">
              <vs-button disabled color="dark" type="border" size="large">
                <span class="dot-pulse-inline"></span> Processando...
              </vs-button>
              <vs-button color="danger" type="filled" icon="cancel" size="large" @click="abrirModalConfirmarCancelamento">
                CANCELAR DISPARO
              </vs-button>
            </div>
          </div>
        </div>

        <!-- ESTADO NORMAL: TABS DE NOVO ENVIO & HISTÓRICO -->
        <div v-else>
          <vs-tabs color="#00bba2" v-model="abaAtiva" v-if="localActive">
            
            <!-- TAB 1: NOVO DISPARO -->
            <vs-tab label="Novo Disparo" icon="send">
              <div class="py-4">
                
                <!-- Info Cards -->
                <div class="info-cards mb-4">
                  <div class="info-card info-card-success">
                    <vs-icon icon="check_circle_outline" size="20px" color="#28c76f"></vs-icon>
                    <div>
                      <span class="info-card-number">{{ osElegiveis.length }}</span>
                      <span class="info-card-text">Prontas para Envio</span>
                    </div>
                  </div>
                  <div class="info-card info-card-warning" v-if="osList.length - osElegiveis.length > 0">
                    <vs-icon icon="warning" size="20px" color="#ff9f43"></vs-icon>
                    <div>
                      <span class="info-card-number">{{ osList.length - osElegiveis.length }}</span>
                      <span class="info-card-text">Sem Contato (Ignoradas)</span>
                    </div>
                  </div>
                </div>

                <!-- Explicação Colapsada -->
                <div class="mb-4">
                  <div 
                    class="help-header" 
                    @click="mostrarComoFunciona = !mostrarComoFunciona"
                  >
                    <vs-icon :icon="mostrarComoFunciona ? 'expand_less' : 'help_outline'" size="16px" class="mr-1"></vs-icon>
                    <span>Como funciona este disparo?</span>
                  </div>
                  <transition name="fade">
                    <div v-if="mostrarComoFunciona" class="help-content mt-2">
                      <p class="text-xs leading-relaxed text-grey-dark" v-if="tipo && tipo.includes('pos_venda')">
                        Das <strong>{{ osList.length }} OS</strong> na lista filtrada, 
                        <strong>{{ osElegiveis.length }}</strong> têm contato de confirmação definido e receberão a mensagem de pós-venda. 
                        As outras <strong>{{ osList.length - osElegiveis.length }}</strong> não têm contato definido e serão ignoradas.
                      </p>
                      <p class="text-xs leading-relaxed text-grey-dark" v-else>
                        Das <strong>{{ osList.length }} OS</strong> na lista filtrada, 
                        <strong>{{ osElegiveis.length }}</strong> têm contato de confirmação definido e receberão a mensagem. 
                        As outras <strong>{{ osList.length - osElegiveis.length }}</strong> não têm contato definido e serão ignoradas. 
                        Ao receberem a mensagem e confirmarem o serviço, elas serão movidas automaticamente para a coluna de <strong>Confirmadas</strong>.
                      </p>
                    </div>
                  </transition>
                </div>

                <!-- Lista de Destinatários Elegíveis -->
                <div class="mb-4" v-if="osElegiveis.length > 0">
                  <div class="flex items-center justify-between mb-2">
                    <label class="select-label m-0">Contatos Selecionados ({{ osSelecionadas.length }} de {{ osElegiveis.length }})</label>
                    <vs-checkbox 
                      @input="toggleAll" 
                      :value="osSelecionadas.length === osElegiveis.length" 
                      color="success"
                      class="text-xs font-semibold text-grey-dark"
                    >
                      Selecionar Todos
                    </vs-checkbox>
                  </div>
                  <div class="destinatarios-lista">
                    <div 
                      v-for="os in osElegiveisExibidos" 
                      :key="os.id" 
                      class="destinatario-item"
                    >
                      <div class="mr-3">
                        <vs-checkbox v-model="osSelecionadas" :vs-value="os.id" color="success"></vs-checkbox>
                      </div>
                      <div class="destinatario-main">
                        <div class="destinatario-os cursor-pointer" @click="toggleOs(os.id)">OS #{{ os.id }}</div>
                        <div class="destinatario-cliente">{{ os.nomeCliente }}</div>
                      </div>
                      <div class="destinatario-contato">
                        <span class="destinatario-nome-contato" v-if="os.nomeContatoConfirmacao">
                          {{ os.nomeContatoConfirmacao }}:
                        </span>
                        <span class="destinatario-fone">{{ os.contatoConfirmacao }}</span>
                      </div>
                    </div>
                    <!-- Carregar Mais / Info Restante -->
                    <div v-if="osElegiveis.length > limiteExibicao" class="text-center py-2" style="background: rgba(0, 187, 162, 0.03); border-top: 1px dashed #edf2f7;">
                      <a href="javascript:void(0)" @click="limiteExibicao += 30" class="text-xs font-semibold" style="color: #00bba2; text-decoration: none;">
                        Mostrar mais {{ Math.min(30, osElegiveis.length - limiteExibicao) }} de {{ osElegiveis.length - limiteExibicao }} contatos...
                      </a>
                    </div>
                  </div>
                </div>

                <!-- Template Select -->
                <div class="mb-6">
                  <label class="select-label">Template de Mensagem WATI</label>
                  
                  <!-- Skeleton Loader para Select -->
                  <div v-if="loadingTemplates" class="skeleton-container">
                    <div class="skeleton-line skeleton-input animate-shimmer"></div>
                  </div>

                  <el-select
                    v-else
                    v-model="templateSelecionadoId"
                    class="w-full"
                    size="medium"
                    placeholder="Selecione o template para envio..."
                    popper-class="popper-select-template"
                    >
                    <el-option
                      v-for="tpl in watiTemplates"
                      :key="tpl.id"
                      :value="tpl.id"
                      :label="tpl.elementName"
                    ></el-option>
                  </el-select>
                </div>

                <!-- Ações -->
                <div class="flex justify-end" style="gap: 12px;">
                  <vs-button color="dark" type="border" @click="closeModal">
                    Cancelar
                  </vs-button>
                  <vs-button 
                    color="#00bba2" 
                    icon="send" 
                    @click="confirmarEnvio"
                    :disabled="osSelecionadas.length === 0 || !templateSelecionadoId"
                  >
                    Confirmar Disparo ({{ osSelecionadas.length }} Contatos)
                  </vs-button>
                </div>

              </div>
            </vs-tab>

            <!-- TAB 2: HISTÓRICO DE ENVIOS -->
            <vs-tab label="Histórico de Envios" icon="history">
              <div class="py-4">
                
                <div class="flex items-center mb-4" style="gap: 12px; background: #f7fafc; padding: 10px; border-radius: 6px; border: 1px solid #edf2f7; display: flex; align-items: center; flex-wrap: wrap; width: 100%;">
                  <span class="text-xs font-bold text-grey-dark" style="color: #4a5568;">Tipo:</span>
                  <el-select 
                    v-model="filtroTipoHistorico" 
                    @change="fetchHistorico(true)"
                    size="small"
                    style="width: 150px;"
                  >
                    <el-option value="all" label="Todos os Envios" />
                    <el-option value="pos_venda" label="Pós-Venda" />
                    <el-option value="os_confirmacao" label="Confirmação de OS" />
                  </el-select>

                  <span class="text-xs font-bold text-grey-dark" style="color: #4a5568; margin-left: 8px;">Período:</span>
                  <select 
                    v-model="filtroHistoricoDias" 
                    @change="aoMudarFiltroDias"
                    style="font-size: 12px; padding: 5px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; width: 140px; font-weight: 600; color: #2d3748; outline: none; height: 32px;"
                  >
                    <option :value="30">Últimos 30 dias</option>
                    <option :value="7">Últimos 7 dias</option>
                    <option :value="60">Últimos 60 dias</option>
                    <option :value="90">Últimos 90 dias</option>
                    <option value="custom">Personalizado</option>
                  </select>

                  <div v-if="filtroHistoricoDias === 'custom'" style="display: flex; align-items: center; gap: 6px;">
                    <span class="text-xs font-bold text-grey-dark" style="color: #4a5568;">De:</span>
                    <input 
                      type="date" 
                      v-model="filtroHistoricoDataInicio" 
                      style="font-size: 12px; padding: 4px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; color: #2d3748; height: 32px;"
                    />
                    <span class="text-xs font-bold text-grey-dark" style="color: #4a5568;">Até:</span>
                    <input 
                      type="date" 
                      v-model="filtroHistoricoDataFim" 
                      style="font-size: 12px; padding: 4px; border: 1px solid #cbd5e0; border-radius: 4px; background: #fff; color: #2d3748; height: 32px;"
                    />
                  </div>

                  <vs-button 
                    color="primary" 
                    size="small" 
                    icon="search" 
                    @click="fetchHistorico(true)"
                    style="height: 32px; margin-left: auto;"
                  >
                    Filtrar
                  </vs-button>
                </div>

                <vs-table 
                  :data="tabelaDados" 
                  max-items="5" 
                  pagination 
                  search 
                  noDataText="Nenhum disparo encontrado."
                  :class="{ 'table-loading': loadingHistorico }"
                >
                  <template slot="thead">
                    <vs-th sort-key="createdAt">Data</vs-th>
                    <vs-th sort-key="templateName">Template</vs-th>
                    <vs-th sort-key="status">Status</vs-th>
                    <vs-th sort-key="enviados">Enviados</vs-th>
                    <vs-th sort-key="confirmados">Confirmados</vs-th>
                    <vs-th>Ações</vs-th>
                  </template>
                  <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                      <vs-td :data="data[indextr].createdAt">
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 120px; height: 16px; border-radius: 4px;"></div>
                        <template v-else>{{ formatData(data[indextr].createdAt) }}</template>
                      </vs-td>
                      <vs-td :data="data[indextr].templateName">
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 160px; height: 16px; border-radius: 4px;"></div>
                        <template v-else>{{ data[indextr].templateName }}</template>
                      </vs-td>
                      <vs-td :data="data[indextr].status">
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 80px; height: 16px; border-radius: 4px;"></div>
                        <vs-chip v-else :color="getStatusColor(data[indextr].status)">
                          {{ data[indextr].status.toUpperCase() }}
                        </vs-chip>
                      </vs-td>
                      <vs-td :data="data[indextr].enviados">
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 50px; height: 16px; border-radius: 4px;"></div>
                        <template v-else>
                          <strong>{{ data[indextr].enviados }}</strong> / {{ data[indextr].totalOs }}
                        </template>
                      </vs-td>
                      <vs-td :data="data[indextr].confirmados">
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 60px; height: 16px; border-radius: 4px;"></div>
                        <template v-else>
                          <span class="text-success font-bold">
                            {{ data[indextr].confirmados || 0 }}
                          </span>
                          <span class="text-grey text-xs">
                            ({{ data[indextr].enviados > 0 ? Math.round(((data[indextr].confirmados || 0) / data[indextr].enviados) * 100) : 0 }}%)
                          </span>
                        </template>
                      </vs-td>
                      <vs-td>
                        <div v-if="data[indextr].isSkeleton" class="skeleton-cell animate-shimmer" style="width: 40px; height: 16px; border-radius: 4px;"></div>
                        <template v-else>
                          <vs-button 
                            v-if="data[indextr].status === 'processing'" 
                            color="primary" 
                            type="border" 
                            size="small" 
                            icon="visibility" 
                            @click="retomarProgresso(data[indextr])"
                          >
                            Ver Progresso
                          </vs-button>
                          <template v-else>
                            <vs-button 
                              v-if="data[indextr].falhas > 0" 
                              color="danger" 
                              type="border" 
                              size="small" 
                              icon="error_outline" 
                              @click="abrirDetalheFalhas(data[indextr].id)"
                            >
                              Ver Falhas ({{ data[indextr].falhas }})
                            </vs-button>
                            <span v-else class="text-xs text-grey font-semibold">✅ Sem Falhas</span>
                          </template>
                        </template>
                      </vs-td>
                    </vs-tr>
                  </template>
                  <template slot="expand" slot-scope="{data}">
                    <div class="px-4 py-3 bg-white" style="border: 1px solid #f8f8f8; border-radius: 8px;">
                      <div class="flex items-center mb-2">
                        <vs-icon icon="info" size="18px" class="mr-2 text-primary"></vs-icon>
                        <h5 class="m-0 text-primary">Detalhes do Disparo #{{ data.id }}</h5>
                      </div>
                      <div class="flex mt-3">
                        <div class="w-1/2 pr-2" v-if="data.idsOsSucesso && data.idsOsSucesso.length > 0">
                          <p class="text-sm font-bold text-success mb-1">
                            <vs-icon icon="check_circle" size="14px"></vs-icon> OSs Enviadas com Sucesso:
                          </p>
                          <div class="flex flex-wrap">
                            <vs-chip color="success" transparent v-for="id in data.idsOsSucesso" :key="'suc_'+id">OS #{{ id }}</vs-chip>
                          </div>
                        </div>
                        <div class="w-1/2 pl-2" v-if="data.idsOsFalha && data.idsOsFalha.length > 0">
                          <p class="text-sm font-bold text-danger mb-1">
                            <vs-icon icon="error_outline" size="14px"></vs-icon> OSs com Falha:
                          </p>
                          <div class="flex flex-wrap">
                            <vs-chip color="danger" transparent v-for="id in data.idsOsFalha" :key="'err_'+id">OS #{{ id }}</vs-chip>
                          </div>
                        </div>
                        <div class="w-full text-center py-4" v-if="(!data.idsOsSucesso || data.idsOsSucesso.length === 0) && (!data.idsOsFalha || data.idsOsFalha.length === 0)">
                          <p class="text-grey text-sm">Nenhum detalhe registrado para este lote.</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </vs-table>
              </div>
            </vs-tab>

          </vs-tabs>
        </div>

      </div>
    </vs-popup>

    <!-- MODAL SECUNDÁRIA DE CONFIRMAÇÃO DE CANCELAMENTO -->
    <vs-popup
      :active.sync="modalConfirmarCancelamento"
      title="⚠️ Confirmar Cancelamento"
      class="modal-confirmar-cancelamento"
    >
      <div class="p-4 text-center">
        <vs-icon icon="warning" size="50px" color="#ea5455" class="mb-3"></vs-icon>
        <h4 class="font-bold text-lg mb-2" style="color: #1e293b;">Tem certeza que deseja cancelar o disparo em massa?</h4>
        <p class="text-sm text-grey mb-6" style="color: #64748b;">
          As mensagens já enviadas (<b>{{ progress.sent }}</b> de <b>{{ progress.total }}</b>) não serão desfeitas, mas os envios pendentes serão interrompidos imediatamente.
        </p>
        <div class="flex justify-center items-center" style="gap: 12px;">
          <vs-button color="dark" type="border" @click="modalConfirmarCancelamento = false">
            Não, Continuar Envio
          </vs-button>
          <vs-button color="danger" type="filled" icon="cancel" @click="confirmarCancelamentoJob" :disabled="cancellingJob">
            {{ cancellingJob ? 'Cancelando...' : 'Sim, Cancelar Envio' }}
          </vs-button>
        </div>
      </div>
    </vs-popup>

    <!-- MODAL DE DETALHAMENTO DE FALHAS -->
    <vs-popup
      :active.sync="modalDetalheFalhas"
      title="📋 Relatório Detalhado de Falhas"
      class="modal-detalhe-falhas"
    >
      <div class="py-4 px-2">
        <div v-if="loadingDetalheFalhas" class="text-center py-6">
          <span class="dot-pulse"></span>
          <p class="text-sm text-grey mt-4">Carregando detalhes...</p>
        </div>
        <div v-else-if="detalheFalhasData.length === 0" class="text-center py-6">
          <vs-icon icon="info" size="40px" color="#94a3b8"></vs-icon>
          <p class="text-sm text-grey mt-2">Nenhum detalhe de falha registrado para este disparo.</p>
        </div>
        <div v-else>
          <div class="detalhe-falhas-header mb-3" style="display: flex; justify-content: space-between; align-items: center; gap: 8px;">
            <span class="text-sm font-bold" style="color: #1e293b;">
              {{ detalheFalhasData.length }} falha(s) registrada(s)
            </span>
            <div style="display: flex; gap: 8px;">
              <vs-button color="success" type="border" size="small" icon="table_view" @click="exportarFalhasExcel">
                Exportar Excel
              </vs-button>
              <vs-button color="primary" type="border" size="small" icon="file_download" @click="exportarFalhasCsv">
                Exportar CSV
              </vs-button>
            </div>
          </div>
          <div class="detalhe-falhas-lista">
            <div 
              v-for="(falha, idx) in detalheFalhasData" 
              :key="idx" 
              class="detalhe-falha-item"
            >
              <div class="detalhe-falha-index">#{{ idx + 1 }}</div>
              <div class="detalhe-falha-main">
                <div class="detalhe-falha-cliente">{{ falha.cliente || '-' }}</div>
                <div class="detalhe-falha-conta">OS #{{ falha.idOs || falha.idConta || '-' }}</div>
              </div>
              <div class="detalhe-falha-contato">
                <span v-if="falha.contatoOriginal" class="text-xs" style="color: #64748b;">{{ falha.contatoOriginal }}</span>
                <span v-else class="text-xs" style="color: #cbd5e1;">sem contato</span>
              </div>
              <div class="detalhe-falha-motivo">
                <vs-chip color="danger" size="small">{{ falha.motivo }}</vs-chip>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center mt-4">
          <vs-button color="dark" type="border" @click="modalDetalheFalhas = false">Fechar</vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { buildGetWatiTemplatesUrl } from "@/constants/watiTemplates";

export default {
  name: "ModalDisparoEmMassa",
  props: {
    active: { type: Boolean, default: false },
    osList: { type: Array, default: () => [] },
    tipo: { type: String, required: true }
  },
  data() {
    return {
      localActive: false,
      modalConfirmarCancelamento: false,
      cancellingJob: false,
      activeJobId: null,
      watiTemplates: [],
      templateSelecionadoId: null,
      osSelecionadas: [],
      etapa: 'selecao', // 'selecao' | 'progresso'
      abaAtiva: 0,
      historico: [],
      filtroTipoHistorico: this.tipo,
      filtroHistoricoDias: 30,
      filtroHistoricoDataInicio: "",
      filtroHistoricoDataFim: "",
      loadingTemplates: false,
      loadingHistorico: false,
      mostrarComoFunciona: false,
      limiteExibicao: 20,
      progress: {
        total: 0,
        sent: 0,
        failed: 0,
        message: 'Aguardando...',
        percent: 0,
        status: ''
      },
      eventSource: null,
      modalDetalheFalhas: false,
      loadingDetalheFalhas: false,
      detalheFalhasData: []
    }
  },
  computed: {
    osElegiveis() {
      // Filtra apenas quem tem contato de confirmação definido
      return this.osList.filter(os => os.id_contato_confirmacao);
    },
    osElegiveisExibidos() {
      return this.osElegiveis.slice(0, this.limiteExibicao);
    },
    templateSelecionadoNome() {
      const tpl = this.watiTemplates.find(t => t.id === this.templateSelecionadoId);
      return tpl ? tpl.elementName : '—';
    },
    tituloModal() {
      if (this.etapa === 'progresso') return 'Enviando Mensagens...';
      return 'Disparo de Mensagem em Massa';
    },
    corStatus() {
      if (this.progress.status === 'completed') {
        if (this.progress.failed > 0) {
          if (this.progress.sent === 0) return '#ea5455';
          return '#ff9f43';
        }
        return '#28c76f';
      }
      if (this.progress.status === 'error') return '#ea5455';
      return '#00bba2';
    },
    tabelaDados() {
      if (this.loadingHistorico && this.historico.length === 0) {
        // Retorna 4 linhas dummy com flag de skeleton
        return Array.from({ length: 4 }).map((_, index) => ({
          id: `skeleton-${index}`,
          createdAt: '',
          templateName: '',
          status: '',
          enviados: 0,
          totalOs: 0,
          confirmados: 0,
          isSkeleton: true
        }));
      }
      return this.historico;
    }
  },
  watch: {
    abaAtiva(val) {
      if (this.localActive) {
        const tabName = val === 1 ? 'historico' : 'novo';
        this.syncUrlQuery(tabName);

        // Carrega os dados da aba selecionada sob demanda (Lazy Loading)
        if (val === 1) {
          this.fetchHistorico();
        } else {
          this.getWatiTemplates();
        }
      }
    },
    active(val) {
      console.log("[ModalDisparoEmMassa] active prop mudou para:", val);
      this.localActive = val;
      if (val) {
        this.templateSelecionadoId = null;
        this.etapa = 'selecao';
        this.mostrarComoFunciona = false;
        this.limiteExibicao = 20;
        this.filtroTipoHistorico = this.tipo;
        this.historico = [];
        this.osSelecionadas = this.osElegiveis.map(os => os.id);
        
        // Sincroniza a aba ativa com base na URL
        const queryTab = this.$route.query.disparo_aba || new URLSearchParams(window.location.search).get('disparo_aba');
        const targetTab = queryTab === 'historico' ? 1 : 0;

        // Se a aba já for a desejada, o watcher não disparará automaticamente, então forçamos a carga
        if (this.abaAtiva === targetTab) {
          if (targetTab === 1) {
            this.fetchHistorico();
          } else {
            this.getWatiTemplates();
          }
        }
        
        // Sincroniza no próximo tick para que os tabs estejam no DOM
        this.$nextTick(() => {
          this.abaAtiva = targetTab;
        });

        console.log("[ModalDisparoEmMassa] Total de OS recebidas (osList):", this.osList.length);
        console.log("[ModalDisparoEmMassa] Total de OS elegíveis (com contato de confirmação):", this.osElegiveis.length);
      }
    },
    localActive(val) {
      if (!val) {
        console.log("[ModalDisparoEmMassa] modal fechado pelo sync.");
        this.closeEventSource();
        
        this.syncUrlQuery(null);

        this.$emit('update:active', false);
      }
    },
    osElegiveis(val) {
      if (this.localActive && this.etapa === 'selecao') {
        this.osSelecionadas = val.map(os => os.id);
      }
    }
  },
  beforeDestroy() {
    console.log("[ModalDisparoEmMassa] beforeDestroy: fechando conexões pendentes.");
    this.localActive = false;
    this.$emit('update:active', false);
    this.closeEventSource();
    this.syncUrlQuery(null);
    // Remove scroll lock style potentially left by Vuesax popup
    if (document && document.body) {
      document.body.style.overflow = '';
    }
  },
  methods: {
    closeEventSource() {
      if (this.eventSource) {
        console.log("[ModalDisparoEmMassa] Fechando EventSource (SSE)...");
        this.eventSource.close();
        this.eventSource = null;
      }
    },
    closeModal() {
      console.log("[ModalDisparoEmMassa] closeModal chamado.");
      this.closeEventSource();
      this.localActive = false;
    },
    fecharComSucesso() {
      console.log("[ModalDisparoEmMassa] fecharComSucesso chamado.");
      this.$emit('success');
      this.closeEventSource();
      this.loadingTemplates = false;
      this.localActive = false;
    },
    toggleAll(val) {
      if (val) {
        this.osSelecionadas = this.osElegiveis.map(os => os.id);
      } else {
        this.osSelecionadas = [];
      }
    },
    toggleOs(id) {
      const idx = this.osSelecionadas.indexOf(id);
      if (idx > -1) {
        this.osSelecionadas.splice(idx, 1);
      } else {
        this.osSelecionadas.push(id);
      }
    },
    confirmarEnvio() {
      if (this.osSelecionadas.length === 0) return;
      console.log("[ModalDisparoEmMassa] abrindo confirmação de envio para template:", this.templateSelecionadoNome);
      this.$vs.dialog({
        type: 'confirm',
        color: '#00bba2',
        title: `Confirmar Disparo`,
        text: `Tem certeza que deseja enviar o template "${this.templateSelecionadoNome}" para ${this.osSelecionadas.length} contatos? Esta ação não poderá ser desfeita.`,
        acceptText: 'Sim, iniciar envio',
        cancelText: 'Cancelar',
        accept: this.executarEnvio
      });
    },
    syncUrlQuery(tabName) {
      try {
        const url = new URL(window.location);
        if (tabName) {
          url.searchParams.set('disparo_aba', tabName);
          window.history.replaceState({}, '', url);
        } else {
          url.searchParams.delete('disparo_aba');
          window.history.replaceState({}, '', url);
        }
      } catch (e) {
        // ignore
      }
    },
    async getWatiTemplates(force = false) {
      if (this.watiTemplates && this.watiTemplates.length > 0 && !force) {
        return;
      }
      console.log("[ModalDisparoEmMassa] Buscando templates do WATI...");
      this.loadingTemplates = true;
      try {
        const url = buildGetWatiTemplatesUrl(this.tipo);
        console.log("[ModalDisparoEmMassa] Efetuando requisição GET para:", url);
        let res = await this.$http.get(url);
        let lista = [];
        if (res && res.data) {
          lista = res.data.data ? res.data.data : (Array.isArray(res.data) ? res.data : (res.data.messageTemplates || []));
        }
        if ((!lista || lista.length === 0) && this.tipo) {
          const fallbackRes = await this.$http.get("getWatiTemplates?filtro[status][]=approved");
          if (fallbackRes && fallbackRes.data) {
            lista = fallbackRes.data.data ? fallbackRes.data.data : (Array.isArray(fallbackRes.data) ? fallbackRes.data : (fallbackRes.data.messageTemplates || []));
          }
        }
        this.watiTemplates = Array.isArray(lista) ? lista : [];
        console.log("[ModalDisparoEmMassa] Resposta templates recebida. Itens carregados:", this.watiTemplates.length || 0);
      } catch (err) {
        console.error("[ModalDisparoEmMassa] Erro ao buscar templates:", err);
        let errorMsg = "Erro ao buscar templates";
        if (err.response && err.response.data && err.response.data.message) errorMsg = err.response.data.message;
        this.$vs.notify({ title: "Erro", text: errorMsg, color: "danger" });
      } finally {
        this.loadingTemplates = false;
      }
    },
    async fetchHistorico(force = false) {
      const selectedType = this.filtroTipoHistorico || this.tipo;
      
      let queryParams = "";
      if (this.filtroHistoricoDias === 'custom') {
        if (this.filtroHistoricoDataInicio) {
          queryParams += (queryParams ? "&" : "?") + `data_inicio=${this.filtroHistoricoDataInicio}`;
        }
        if (this.filtroHistoricoDataFim) {
          queryParams += (queryParams ? "&" : "?") + `data_fim=${this.filtroHistoricoDataFim}`;
        }
      } else {
        queryParams += (queryParams ? "&" : "?") + `dias=${this.filtroHistoricoDias}`;
      }

      if (this.historico && this.historico.length > 0 && !force) {
        console.log("[ModalDisparoEmMassa] Histórico já carregado (cache). Buscando em background...");
        try {
          const res = await this.$http.get(`whatsapp/enviar-massa/historico/${selectedType}${queryParams}`);
          const responseData = res.data || res;
          this.historico = Array.isArray(responseData) ? responseData : (responseData.data || []);
        } catch (err) {
          console.error("[ModalDisparoEmMassa] Erro ao buscar histórico em background:", err);
        }
        return;
      }
      console.log("[ModalDisparoEmMassa] Buscando histórico...");
      this.loadingHistorico = true;
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/historico/${selectedType}${queryParams}`);
        console.log("[ModalDisparoEmMassa] Histórico recebido:", res.data);
        const responseData = res.data || res;
        this.historico = Array.isArray(responseData) ? responseData : (responseData.data || []);
      } catch (err) {
        console.error("[ModalDisparoEmMassa] Erro ao buscar histórico:", err);
      } finally {
        this.loadingHistorico = false;
      }
    },
    aoMudarFiltroDias() {
      if (this.filtroHistoricoDias !== 'custom') {
        this.fetchHistorico(true);
      }
    },
    formatData(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString('pt-BR');
    },
    getStatusColor(status) {
      if (status === 'completed') return 'success';
      if (status === 'error') return 'danger';
      return 'warning';
    },
    retomarProgresso(job) {
      if (job.status !== 'processing') return;
      this.activeJobId = job.id;
      this.etapa = 'progresso';
      this.progress = {
        total: job.totalOs,
        sent: job.enviados,
        failed: job.falhas,
        message: 'Reconectando ao envio...',
        percent: Math.round(((job.enviados + job.falhas) / job.totalOs) * 100) || 0,
        status: job.status
      };
      this.iniciarProgressoSSE(job.id);
    },
    abrirModalConfirmarCancelamento() {
      this.modalConfirmarCancelamento = true;
    },
    async confirmarCancelamentoJob() {
      this.cancellingJob = true;
      try {
        await this.$http.post('whatsapp/enviar-massa/cancelar-job', {
          jobId: this.activeJobId,
          tipo: this.tipo
        });
        this.progress.status = 'cancelled';
        this.progress.message = 'Disparo cancelado pelo usuário';
        this.closeEventSource();
        this.$vs.notify({
          title: "Cancelado",
          text: "O disparo em massa foi interrompido com sucesso.",
          color: "warning"
        });
        this.fetchHistorico(true);
      } catch (err) {
        this.$vs.notify({
          title: "Erro",
          text: "Falha ao cancelar o disparo.",
          color: "danger"
        });
      } finally {
        this.cancellingJob = false;
        this.modalConfirmarCancelamento = false;
      }
    },
    async executarEnvio() {
      console.log("[ModalDisparoEmMassa] confirmarEnvio aceito. Iniciando fluxo de envio...");
      this.etapa = 'progresso';
      this.progress = {
        total: this.osElegiveis.length,
        sent: 0,
        failed: 0,
        message: 'Iniciando envio em lote...',
        percent: 0,
        status: 'processing'
      };

      try {
        const template = this.watiTemplates.find(t => t.id === this.templateSelecionadoId);
        const equipes = this.tipo === "os_confirmacao" ? ["Equipe Confirmação"] : null;
        const idsOs = this.osSelecionadas;

        const payload = {
          idsOs,
          templateName: template ? template.elementName : this.tipo,
          templateId: this.templateSelecionadoId,
          tipo: this.tipo,
          equipes
        };
        console.log("[ModalDisparoEmMassa] POST whatsapp/enviarTemplateEmMassa. Payload:", payload);

        const res = await this.$http.post("whatsapp/enviarTemplateEmMassa", payload);
        console.log("[ModalDisparoEmMassa] Resposta enviarTemplateEmMassa recebida:", res);

        const responseData = res.data || res;
        const jobId = responseData.data ? responseData.data.jobId : responseData.jobId;
        this.activeJobId = jobId;
        
        console.log("[ModalDisparoEmMassa] JobID criado:", jobId);
        this.iniciarProgressoSSE(jobId);
      } catch (err) {
        console.error("[ModalDisparoEmMassa] Erro ao disparar lote de templates:", err);
        this.progress.status = 'error';
        this.progress.message = 'Falha ao iniciar o envio em lote.';
        const errorData = err.response ? err.response.data : {};
        this.$vs.notify({ title: "Erro", text: errorData.message || "Erro ao enviar.", color: "danger" });
      }
    },
    async abrirDetalheFalhas(jobId) {
      this.modalDetalheFalhas = true;
      this.loadingDetalheFalhas = true;
      this.detalheFalhasData = [];
      try {
        const res = await this.$http.get(`whatsapp/enviar-massa/detalhe-falhas/${jobId}`);
        const responseData = res.data || res;
        const data = responseData.data || responseData;
        this.detalheFalhasData = data.detalheFalhas || [];
      } catch (err) {
        console.error('[ModalDisparoEmMassa] Erro ao buscar detalhe de falhas:', err);
        this.$vs.notify({ title: 'Erro', text: 'Erro ao buscar detalhes de falhas.', color: 'danger' });
      } finally {
        this.loadingDetalheFalhas = false;
      }
    },
    exportarFalhasExcel() {
      if (!this.detalheFalhasData || this.detalheFalhasData.length === 0) return;
      try {
        const XLSX = require('xlsx');
        const rows = [
          ['OS / Conta', 'Cliente', 'Contato Original', 'Motivo da Falha']
        ];
        this.detalheFalhasData.forEach(f => {
          rows.push([
            f.idOs || f.idConta || '-',
            f.cliente || '-',
            f.contatoOriginal || 'Sem contato',
            f.motivo || '-'
          ]);
        });
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.aoa_to_sheet(rows);
        ws['!cols'] = [
          { wch: 15 },
          { wch: 35 },
          { wch: 25 },
          { wch: 45 }
        ];
        XLSX.utils.book_append_sheet(wb, ws, 'Falhas');
        const filename = `relatorio_falhas_${this.tipo || 'disparo'}_${new Date().toISOString().split('T')[0]}.xlsx`;
        XLSX.writeFile(wb, filename);
        this.$vs.notify({ title: 'Sucesso', text: 'Planilha Excel gerada com sucesso!', color: 'success' });
      } catch (err) {
        console.error('Erro ao exportar Excel:', err);
        this.$vs.notify({ title: 'Erro', text: 'Erro ao gerar arquivo Excel.', color: 'danger' });
      }
    },
    exportarFalhasCsv() {
      if (!this.detalheFalhasData || this.detalheFalhasData.length === 0) return;
      const header = 'OS / Conta;Cliente;Contato Original;Motivo';
      const linhas = this.detalheFalhasData.map(f => 
        `${f.idOs || f.idConta || '-'};${(f.cliente || '-').replace(/;/g, ',')};${(f.contatoOriginal || '-').replace(/;/g, ',')};${(f.motivo || '-').replace(/;/g, ',')}`
      );
      const csv = [header, ...linhas].join('\n');
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `relatorio_falhas_${this.tipo || 'disparo'}_${new Date().toISOString().split('T')[0]}.csv`;
      link.click();
    },
    iniciarProgressoSSE(jobId) {
      const baseUrl = this.$http.defaults.baseURL || '';
      const url = `${baseUrl.replace(/\/$/, '')}/whatsapp/enviar-massa/progress/${jobId}`;
      console.log("[ModalDisparoEmMassa] Estabelecendo conexão EventSource (SSE) com:", url);
      
      this.eventSource = new EventSource(url);

      this.eventSource.onmessage = (event) => {
        try {
          const data = JSON.parse(event.data);
          console.log("[ModalDisparoEmMassa] SSE Evento recebido:", data);
          
          if (data.status === 'error' && data.message === 'Job não encontrado') {
            console.warn("[ModalDisparoEmMassa] SSE: Job não encontrado.");
            this.closeEventSource();
            return;
          }
          const oldStatus = this.progress.status;
          this.progress.status = data.status;
          this.progress.total = data.total || this.progress.total;
          this.progress.sent = data.sent || 0;
          this.progress.failed = data.failed || 0;
          this.progress.message = data.message;

          const processados = this.progress.sent + this.progress.failed;
          this.progress.percent = this.progress.total > 0 ? Math.round((processados / this.progress.total) * 100) : 0;
          console.log(`[ModalDisparoEmMassa] Progresso atualizado: ${processados}/${this.progress.total} (${this.progress.percent}%)`);

          if (data.status === 'completed') {
            console.log("[ModalDisparoEmMassa] SSE: Status completed!");
            this.progress.percent = 100;
            this.closeEventSource();
            if (oldStatus !== 'completed') {
              this.$vs.notify({ title: "Sucesso!", text: "Disparo em massa concluído!", color: "success" });
            }
            this.fetchHistorico(true);
          } else if (data.status === 'error') {
            console.error("[ModalDisparoEmMassa] SSE: Status error!", data.message);
            this.closeEventSource();
            if (oldStatus !== 'error') {
              this.$vs.notify({ title: "Erro", text: data.message || "Erro no servidor.", color: "danger" });
            }
            this.fetchHistorico(true);
          }
        } catch (e) {
          console.error("[ModalDisparoEmMassa] Falha no parse dos dados SSE:", e);
        }
      };

      this.eventSource.onerror = (e) => {
        console.error("[ModalDisparoEmMassa] SSE conexão encontrou um erro:", e);
        this.closeEventSource();
        if (this.progress.status === 'processing') {
          console.log("[ModalDisparoEmMassa] Convertendo status para concluído devido à perda de conexão.");
          this.progress.status = 'completed';
          this.$vs.notify({ title: "Aviso", text: "Conexão perdida, mas envios continuam no servidor.", color: "warning" });
          this.fetchHistorico(true);
        }
      };
    }
  }
}
</script>

<style lang="scss">
.modal-historico-largo .vs-popup {
  width: 900px !important;
  max-width: 95vw !important;
  transition: width 0.3s ease, max-width 0.3s ease;
}
.modal-disparo-massa .vs-popup {
  transition: width 0.3s ease, max-width 0.3s ease;
}

/* Ensure Vuesax confirm dialogs are on top of popups */
.con-vs-dialog {
  z-index: 70000 !important;
}
</style>


<style scoped>
/* ═══ Pagination Skeleton ═══ */
::v-deep .table-loading .con-pagination-table {
  pointer-events: none;
  position: relative;
  min-height: 38px;
}
::v-deep .table-loading .con-pagination-table * {
  visibility: hidden;
}
::v-deep .table-loading .con-pagination-table::after {
  content: '';
  position: absolute;
  top: 6px;
  right: 12px;
  width: 180px;
  height: 28px;
  background: linear-gradient(90deg, #edf2f7 25%, #e2e8f0 50%, #edf2f7 75%);
  background-size: 200% 100%;
  animation: shimmer-animation 1.5s infinite;
  border-radius: 6px;
  cursor: wait;
}


.skeleton-cell {
  background: #edf2f7;
  cursor: wait;
}

::v-deep .modal-disparo-massa .vs-popup {
  max-width: 650px;
}

/* ═══ Custom Close Button ═══ */
.custom-modal-close {
  position: absolute;
  top: -45px;
  right: 15px;
  cursor: pointer;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  color: #ffffff;
  transition: all 0.2s ease;
}
.custom-modal-close:hover {
  transform: scale(1.1);
  color: #ea5455;
}

/* ═══ Info Cards ═══ */
.info-cards {
  display: flex;
  gap: 12px;
}
.info-card {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: 10px;
  flex: 1;
}
.info-card-success {
  background: rgba(40, 199, 111, 0.08);
  border: 1px solid rgba(40, 199, 111, 0.2);
}
.info-card-warning {
  background: rgba(255, 159, 67, 0.08);
  border: 1px solid rgba(255, 159, 67, 0.2);
}
.info-card-number {
  font-size: 1.3rem;
  font-weight: 700;
  display: block;
  line-height: 1;
}
.info-card-text {
  font-size: 0.75rem;
  color: #828d99;
  display: block;
}

/* ═══ Help Panel ═══ */
.help-header {
  display: flex;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 700;
  color: #00bba2;
  cursor: pointer;
  user-select: none;
  width: fit-content;
  padding: 6px 12px;
  border-radius: 6px;
  background: rgba(0, 187, 162, 0.05);
  transition: all 0.2s ease;
}
.help-header:hover {
  background: rgba(0, 187, 162, 0.1);
}
.help-content {
  padding: 12px;
  border-radius: 8px;
  background-color: #f7fafc;
  border-left: 4px solid #00bba2;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* ═══ Destinatários ═══ */
.destinatarios-lista {
  max-height: 160px;
  overflow-y: auto;
  border: 1px solid #edf2f7;
  border-radius: 8px;
  background: #f8f9fb;
  padding: 8px;
}
.destinatario-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 12px;
  border-bottom: 1px solid #edf2f7;
}
.destinatario-item:last-child {
  border-bottom: none;
}
.destinatario-main {
  display: flex;
  flex-direction: column;
}
.destinatario-os {
  font-size: 0.75rem;
  font-weight: 700;
  color: #00bba2;
}
.destinatario-cliente {
  font-size: 0.85rem;
  font-weight: 600;
  color: #2d3748;
}
.destinatario-contato {
  text-align: right;
  font-size: 0.8rem;
}
.destinatario-nome-contato {
  color: #718096;
  font-weight: 500;
}
.destinatario-fone {
  color: #2d3748;
  font-weight: 700;
}

/* ═══ Select ═══ */
.select-label {
  display: block;
  font-weight: 600;
  font-size: 0.85rem;
  margin-bottom: 8px;
  color: #4a5568;
}

/* ═══ Skeleton Loading ═══ */
.skeleton-container {
  width: 100%;
  cursor: wait;
}
.skeleton-line {
  background: #e2e8f0;
  border-radius: 4px;
  cursor: wait;
}
.skeleton-input {
  height: 40px;
  width: 100%;
}
.skeleton-row {
  height: 40px;
  width: 100%;
  margin-bottom: 8px;
  border-radius: 4px;
  cursor: wait;
}
.skeleton-row:last-child {
  margin-bottom: 0;
}
.animate-shimmer {
  background: linear-gradient(90deg, #edf2f7 25%, #e2e8f0 50%, #edf2f7 75%);
  background-size: 200% 100%;
  animation: shimmer-animation 1.5s infinite;
}
@keyframes shimmer-animation {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ═══ Progress Bar ═══ */
.progress-container {
  padding: 0 8px;
}
.progress-info {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}
.progress-bar-bg {
  width: 100%;
  height: 12px;
  background: #e2e8f0;
  border-radius: 999px;
  overflow: hidden;
}
.progress-bar-fill {
  height: 100%;
  border-radius: 999px;
  transition: width 0.6s ease;
}

/* ═══ Counters ═══ */
.counters-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}
.counter-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 16px 8px;
  border-radius: 12px;
  background: #f8f9fb;
  border: 1px solid #edf2f7;
}
.counter-value {
  font-size: 1.6rem;
  font-weight: 800;
  line-height: 1;
}
.counter-label {
  font-size: 0.75rem;
  color: #a0aec0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* ═══ Spinner ═══ */
.spinner-pulse {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: #00bba2;
  margin: 0 auto;
  animation: pulse-ring 1.2s ease-in-out infinite;
}
@keyframes pulse-ring {
  0% { transform: scale(0.8); opacity: 1; }
  50% { transform: scale(1.1); opacity: 0.5; }
  100% { transform: scale(0.8); opacity: 1; }
}
.animate-bounce-in {
  animation: bounceIn 0.5s ease;
}
@keyframes bounceIn {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

/* ═══ Dot Pulse ═══ */
.dot-pulse-inline {
  display: inline-block;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #a0aec0;
  margin-right: 4px;
  animation: dot-blink 1s infinite;
}
@keyframes dot-blink {
  0%, 100% { opacity: 0.3; }
  50% { opacity: 1; }
}

/* ═══ Detalhe de Falhas ═══ */
.detalhe-falhas-lista {
  max-height: 400px;
  overflow-y: auto;
  border: 1px solid #edf2f7;
  border-radius: 6px;
}
.detalhe-falha-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  border-bottom: 1px solid #f1f5f9;
  gap: 12px;
}
.detalhe-falha-item:last-child {
  border-bottom: none;
}
.detalhe-falha-item:hover {
  background: #f8fafc;
}
.detalhe-falha-index {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  min-width: 28px;
}
.detalhe-falha-main {
  flex: 1;
  min-width: 0;
}
.detalhe-falha-cliente {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.detalhe-falha-conta {
  font-size: 11px;
  color: #64748b;
}
.detalhe-falha-contato {
  min-width: 120px;
  text-align: right;
}
.detalhe-falha-motivo {
  min-width: 140px;
}
</style>

<style lang="scss">
.popper-select-template {
  z-index: 999999 !important;
}

.modal-detalhe-falhas .vs-popup {
  max-width: 800px !important;
  width: 90% !important;
}

.vs-component.con-vs-dialog,
.vs-dialog-promise,
.con-vs-dialog,
.modal-confirmar-cancelamento,
.modal-confirmar-cancelamento.vs-component {
  z-index: 300000 !important;
  .vs-popup--background {
    z-index: 300000 !important;
  }
  .vs-popup {
    z-index: 300001 !important;
  }
}
</style>
